import axios from 'axios';
import Common from '../../componets/Common';

export const generarSessionPagoVisa = async (idComercio, data, tv) => {

  const total = parseFloat(data.detail.total.replace(",", ".")).toFixed(2)
  const ip = require("ip");

  const datos = {
    amount: total,
    antifraud: {
      clientIp: ip.address(),
      merchantDefineData: {
        // MDD4: "estudiante@upn.pe",
        MDD30: data.detail.studentCode.replace("N", ""),
        MDD32: data.detail.studentCode,
        MDD63: "DNI",
        MDD65: data.detail.studentCode.replace("N", ""),
        MDD75: "Registrado",
        MDD77: data.detail.dias,
      },
    },
    channel: "web",
    recurrenceMaxAmount: null,
  };

  const auth = {
    headers: {
      Authorization: tv,
    },
  };

  const resSession = await axios
              .post(
                `${Common.urlAPISession}${idComercio}`,
                datos,
                auth
              )
              .catch((error) => {
                if (
                  error.response.status === 400 &&
                  error.response.data.errorMessage ===
                    "Token has been used before"
                ) {
                  alert(
                    "El token ha sido usado por favor vuelva a generar uno accediendo desde su portal de pagos."
                  );
                } else if (error.response.status === 400) {
                  alert(error.response.data.errorMessage);
                }
              });

  return resSession;
}
